export const SHOW_ALERT = 'SHOW_ALERT'
export const showAlert = (data) => ({
  type: SHOW_ALERT,
  payload: { ...data, show: true },
})
export const closeAlert = () => ({
  type: SHOW_ALERT,
  payload: {
    show: false,
    text: '',
    important: '',
    type: 'success',
    extraData: {},
  },
})

const initialState = {
  show: false,
  text: '',
  important: '',
  type: 'success',
  extraData: {},
}
export const getAlertData = (state) => state.alert

export const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ALERT:
      return action.payload
    default:
      return state
  }
}
